<script setup>
import { Link } from '@inertiajs/vue3'
import { Button } from '@/Components/ui/button'
import { PiggyBank, CircleCheck } from 'lucide-vue-next'
import { tutors } from '@/routes/index'

const pricingOptions = [
  {
    title: 'Content access only',
    description: 'Watch recorded lessons and use resources'
  },
  {
    title: 'Group learning',
    description: 'Small group sessions with peers'
  },
  {
    title: '1:1 tutoring',
    description: 'Personal attention and custom learning'
  }
]
</script>

<template>
  <section class="py-12 md:py-24 bg-white">
    <div class="max-w-7xl mx-auto px-8">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        <!-- Left Content - Pricing Card -->
        <div class="lg:col-span-6">
          <div class="bg-gradient-to-br from-blue-600 to-purple-600 rounded-3xl p-12 text-white shadow-2xl">
            <div class="mb-8">
              <PiggyBank class="w-16 h-16 opacity-90" />
            </div>
            <h3 class="text-3xl font-bold mb-4">Flexible pricing options</h3>
            <div class="space-y-4">
              <div
                v-for="(option, index) in pricingOptions"
                :key="index"
                class="flex items-start space-x-3"
              >
                <CircleCheck class="w-6 h-6 mt-1 shrink-0" />
                <div>
                  <p class="font-semibold text-lg">{{ option.title }}</p>
                  <p class="text-blue-100">{{ option.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Content -->
        <div class="lg:col-span-6">
          <h2 class="text-3xl md:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Top-quality tutoring, made more affordable
          </h2>
          <p class="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed">
            Bindle makes high-quality tutoring flexible and accessible by providing recorded
            content, group sessions and 1:1 tutoring as weekly
            subscription plans. Learn at a pace that suits you, without the
            cost or rigidity of traditional private tutoring.
          </p>
          <p class="text-lg md:text-lg text-gray-700 font-medium mb-8">
            Choose the level of support you need — from content access to
            group learning to 1:1 tutoring.
          </p>
          <div class="flex">
              <Link :href="tutors()" class="block w-full md:w-auto text-center md:text-left px-6 md:px-8 py-4 bg-blue-600 text-white rounded-xl font-semibold text-base md:text-lg hover:bg-blue-700 transition-all hover:shadow-lg">
                  Find a Tutor Plan
              </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
